import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { GoAlert } from 'react-icons/go';
import { useHistory } from 'react-router-dom';

import './dialogVerificacaoPlano.css';

export const DialogVerificacaoPlano = ({ inscricao, openModal, closeModal, subGrupo,foraDicionario=false,arrayMsgErro=[] }) => {
    const history = useHistory();
    const [visible, setVisible] = useState(false);
    const [dicionarioDePlanos] = useState({
        'ZI': 'Zelo Ideal',
        'ZU': 'Zelo Sob Medida',
        'ZTA': 'Zelo Troca Aberta',
        'default': 'Zelo'
    });
    const msgPlural = 'Não foi possível dar continuidade na edição deste contrato, pois existem dependentes cadastrados que não atendem as regras para o plano que você deseja trocar. Abaixo estão as validações infringidas. ';
    const msgSingular = 'Não foi possível dar continuidade na edição deste contrato, pois existe pelo menos um dependente cadastrado que não atende as regras para o plano que você deseja trocar. Abaixo está a validação infringida.';
    const plano = subGrupo.trim() !== 'ZTA' ? subGrupo.trim().substr(0, 2) : subGrupo.trim();
    const onHide = () => setVisible(closeModal);
    const onShow = () => setVisible(openModal);
    
    const irParaPaginaDeDependentes = () => {
        setVisible(closeModal);
        history.push(`/cadastrar-dependentes/${inscricao}`);
    };
    
    useEffect(() => {
        onShow();
    }, [openModal]);    
    
    const footer = (
        <div className="button-container">
            <Button
                label="Ir para Cadastrar de Dependentes"
                icon="pi pi-arrow-right"
                onClick={irParaPaginaDeDependentes}
            />
        </div>
    );
    const msgZi = (<p>
        Por gentileza, volte a etapa de cadastrar dependentes e edite os dependentes
        conforme as regras do plano {`${dicionarioDePlanos[plano] || dicionarioDePlanos.default}`}.
    </p>);

    const msgForaZi = (<>
        <h4>{arrayMsgErro.length > 0 ? msgPlural : msgSingular}</h4>

        <ul style={{ color: 'red' }}>
            {arrayMsgErro.map((erro, idx) => <li key={idx}>{erro}</li>)}
        </ul>
        <h5 className='msg-dica'>E agora, o que fazer? Você deve acessar a página de cadastro de dependentes, clicando no botão abaixo. Lá deverão ser feitas as correções apontadas acima, você poderá optar por editar os dependentes, caso isto seja o suficiente para corrigir o que está fora da regra, ou você poderá excluí-los, trocar o plano e cadastrá-los novamente.</h5>
    </>);
    const body = (
        <div className="dialog-plano">
            <GoAlert size={50} color="orange" />
            {!foraDicionario && msgZi}
            
            {foraDicionario && 
                msgForaZi
            }
            
        </div>
    );

    return (
        <Dialog
            header={'Atenção, detectamos problemas relacionados aos dependentes.'}
            footer={footer}
            visible={visible}
            style={{ width: '60vw' }}
            modal
            closable
            showHeader
            onHide={onHide}
        >
            {body}
        </Dialog>
    );
};
